import { create } from 'zustand';
import axiosClient from '../services/api';

const useQuizStore = create((set, get) => ({
  quiz: null,
  quizzes: [],
  isLoading: false,
  error: null,

  // Actions
  fetchQuiz: async (quizId) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axiosClient.get(`/learning/quizzes/${quizId}`);
      set({
        quiz: response.data.data,
        isLoading: false
      });
      return response.data.quiz;
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to fetch quiz';
      set({
        error: errorMessage,
        isLoading: false
      });
      return null;
    }
  },

  createQuiz: async (quizData) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axiosClient.post(`/learning/quizzes`, quizData);
      set({ isLoading: false });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to create quiz';
      set({
        error: errorMessage,
        isLoading: false
      });
      return null;
    }
  },

  updateQuiz: async (quizId, quizData) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axiosClient.put(`/learning/quizzes/${quizId}`, quizData);
      set({ isLoading: false });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to update quiz';
      set({
        error: errorMessage,
        isLoading: false
      });
      return null;
    }
  },

  deleteQuiz: async (quizId) => {
    set({ isLoading: true, error: null });
    try {
      await axiosClient.delete(`/quizzes/${quizId}`);
      set({ isLoading: false });
      return true;
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to delete quiz';
      set({
        error: errorMessage,
        isLoading: false
      });
      return null;
    }
  },

  addQuestion: async (quizId, questionData) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axiosClient.post(`/learning/quizzes/${quizId}/questions`, questionData);
      set({ isLoading: false });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to add question';
      set({
        error: errorMessage,
        isLoading: false
      });
      return null;
    }
  },

  updateQuestion: async (quizId, questionId, questionData) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axiosClient.put(`/learning/quizzes/${quizId}/questions/${questionId}`, questionData);
      set({ isLoading: false });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to update question';
      set({
        error: errorMessage,
        isLoading: false
      });
      return null;
    }
  },

  deleteQuestion: async (quizId, questionId) => {
    set({ isLoading: true, error: null });
    try {
      await axiosClient.delete(`/learning/quizzes/${quizId}/questions/${questionId}`);
      set({ isLoading: false });
      return true;
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to delete question';
      set({
        error: errorMessage,
        isLoading: false
      });
      return null;
    }
  },

  clearError: () => set({ error: null }),
}));

export default useQuizStore;